/**
 * @generated SignedSource<<20606257847017315b5bf6a4cc55b718>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferralPartnerLayout_referralPartner$data = {
  readonly name: string;
  readonly slug: string | null;
  readonly " $fragmentType": "ReferralPartnerLayout_referralPartner";
};
export type ReferralPartnerLayout_referralPartner$key = {
  readonly " $data"?: ReferralPartnerLayout_referralPartner$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReferralPartnerLayout_referralPartner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReferralPartnerLayout_referralPartner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "ReferralPartner",
  "abstractKey": null
};

(node as any).hash = "23212cfb2221eb4939ace02b86f37c79";

export default node;
